<div class="row">
  <div class="col-md-9">
    <h1 mat-dialog-title>Create Admin Utility Report Info</h1>
  </div>
  <div class="col-md-3">
    <button class="btn btn-danger pull-right" (click)="closeDialog()">X</button>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="utilityReportForm" role="form">
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Current Status</label>
        <input
          type="text"
          class="form-control"
          formControlName="currentStatus"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Status</label>
        <input type="text" class="form-control" formControlName="status" />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Customer ID</label>
        <input type="text" class="form-control" formControlName="customerID" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Brand</label>
        <input type="text" class="form-control" formControlName="brand" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">TDSP</label>
        <input type="text" class="form-control" formControlName="tdsp" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">ProfileCreationDate</label>
        <input
          type="text"
          class="form-control"
          formControlName="profileCreationDate"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">UtilityName</label>
        <input type="text" class="form-control" formControlName="utilityName" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Signup Date</label>
        <input type="text" class="form-control" formControlName="signupDate" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Signup Time</label>
        <input type="text" class="form-control" formControlName="signupTime" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">First Name</label>
        <input type="text" class="form-control" formControlName="firstName" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Last Name</label>
        <input type="text" class="form-control" formControlName="lastName" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Email Address</label>
        <input
          type="text"
          class="form-control"
          formControlName="emailAddress"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Home Phone</label>
        <input type="text" class="form-control" formControlName="homePhone" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Mobile Phone</label>
        <input type="text" class="form-control" formControlName="mobilePhone" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Work Phone</label>
        <input type="text" class="form-control" formControlName="workPhone" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label"
          >Authorized Representative</label
        >
        <input
          type="text"
          class="form-control"
          formControlName="authorizedRepresentative"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">ESIID</label>
        <input type="text" class="form-control" formControlName="eSIID" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Service Address 1</label>
        <input
          type="text"
          class="form-control"
          formControlName="serviceAddress1"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Service Address 2</label>
        <input
          type="text"
          class="form-control"
          formControlName="serviceAddress2"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Service City</label>
        <input type="text" class="form-control" formControlName="serviceCity" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Service State</label>
        <input
          type="text"
          class="form-control"
          formControlName="serviceState"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Service Zip Code</label>
        <input
          type="text"
          class="form-control"
          formControlName="serviceZipCode"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Billing Address 1</label>
        <input
          type="text"
          class="form-control"
          formControlName="billingAddress1"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Billing Address 2</label>
        <input
          type="text"
          class="form-control"
          formControlName="billingAddress2"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Billing City</label>
        <input type="text" class="form-control" formControlName="billingCity" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Billing State</label>
        <input
          type="text"
          class="form-control"
          formControlName="billingState"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Billing Zip Code</label>
        <input
          type="text"
          class="form-control"
          formControlName="billingZipCode"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Service Type</label>
        <input type="text" class="form-control" formControlName="serviceType" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Requested Start Date</label>
        <input
          type="text"
          class="form-control"
          formControlName="requestedStartDate"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">End Date</label>
        <input type="text" class="form-control" formControlName="endDate" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Energy Rate</label>
        <input type="text" class="form-control" formControlName="energyRate" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Avg Usage</label>
        <input type="text" class="form-control" formControlName="avgUsage" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Term</label>
        <input type="text" class="form-control" formControlName="term" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Plan Name</label>
        <input type="text" class="form-control" formControlName="planName" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">Renewable Content</label>
        <input
          type="text"
          class="form-control"
          formControlName="renewableContent"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Enrollment Source</label>
        <input
          type="text"
          class="form-control"
          formControlName="enrollmentSource"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Promo Code</label>
        <input type="text" class="form-control" formControlName="promoCode" />
      </div>
    </div>
    <div class="pull-right mt-2">
      <button class="btn btn-primary" (click)="postDataOfNewEnergyProvider()">
        Submit
      </button>
      <button class="btn btn-danger" (click)="closeDialog()">Cancel</button>
    </div>
  </form>
  <!-- <input matInput [(ngModel)]="data.animal"> -->
</div>
